import { render, staticRenderFns } from "./regionGrow.vue?vue&type=template&id=24c7f8be"
import script from "./regionGrow.vue?vue&type=script&lang=js"
export * from "./regionGrow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports